module.exports = __webpack_public_path__ + "static/img/14bac.ee98730.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/gameNewPic/14bac.jpg
// module id = wC3j
// module chunks = 1